import { Card, SimpleGrid, Text, Tooltip } from "@mantine/core";
import { useSnapshot } from "valtio";
import { assistantLogTexts } from "@/locales/assistant-log";
import { i18nStore } from "@/store/i18n";
import type { AssistantLogOverviewDto } from "@/types/ai-assistant-log";
import {
	formatLogCost,
	formatLogCount,
	formatLogTokens,
} from "./log-format.logic";

/** Lima stat card lapis 1: angka seluruh rentang, bukan hanya halaman yang tampil. */
export function LogStats({
	overview,
}: {
	overview: AssistantLogOverviewDto | null;
}) {
	const { lang: uiLang } = useSnapshot(i18nStore);
	const lang = uiLang === "en" ? "en" : "id";
	const t = assistantLogTexts[lang];

	const cards = [
		{
			label: t.statActiveUsers,
			value: formatLogCount(overview?.activeUsers ?? 0, lang),
		},
		{
			label: t.statConversations,
			value: formatLogCount(overview?.conversations ?? 0, lang),
		},
		{ label: t.statTurns, value: formatLogCount(overview?.turns ?? 0, lang) },
		{
			label: t.statTokens,
			value: overview
				? formatLogTokens(overview.inputTokens, overview.outputTokens, lang)
				: formatLogTokens(0, 0, lang),
		},
		{
			label: t.statCost,
			value: overview ? formatLogCost(overview.cost, t, lang) : t.costUnknown,
			hint: overview?.cost.incomplete ? t.costIncomplete : undefined,
		},
	];

	return (
		<SimpleGrid cols={{ base: 1, xs: 2, md: 5 }} spacing="sm" data-log-stats>
			{cards.map((card) => (
				<Card key={card.label} withBorder radius="md" p="md">
					<Text size="xs" c="dimmed" tt="uppercase" fw={600}>
						{card.label}
					</Text>
					{card.hint ? (
						<Tooltip label={card.hint} openDelay={300}>
							<Text size="lg" fw={700} mt={4}>
								{card.value}
							</Text>
						</Tooltip>
					) : (
						<Text size="lg" fw={700} mt={4}>
							{card.value}
						</Text>
					)}
				</Card>
			))}
		</SimpleGrid>
	);
}
